import { render } from "./ClientCajasMovimientos.vue?vue&type=template&id=0bcd3a4a"
import script from "./ClientCajasMovimientos.vue?vue&type=script&lang=js"
export * from "./ClientCajasMovimientos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__